__turbopack_context__.v({
  "backBtn": "NewsHeader-module__6r8btq__backBtn",
  "closeMenuBtn": "NewsHeader-module__6r8btq__closeMenuBtn",
  "container": "NewsHeader-module__6r8btq__container",
  "fadeInItems": "NewsHeader-module__6r8btq__fadeInItems",
  "header": "NewsHeader-module__6r8btq__header",
  "link": "NewsHeader-module__6r8btq__link",
  "linkActive": "NewsHeader-module__6r8btq__linkActive",
  "links": "NewsHeader-module__6r8btq__links",
  "mobileHeader": "NewsHeader-module__6r8btq__mobileHeader",
  "mobileMenu": "NewsHeader-module__6r8btq__mobileMenu",
  "mobileMenuBtn": "NewsHeader-module__6r8btq__mobileMenuBtn",
  "mobileMenuItem": "NewsHeader-module__6r8btq__mobileMenuItem",
  "mobileMenuLabel": "NewsHeader-module__6r8btq__mobileMenuLabel",
  "mobileMenuVisible": "NewsHeader-module__6r8btq__mobileMenuVisible",
  "mobileTitle": "NewsHeader-module__6r8btq__mobileTitle",
  "shareBtn": "NewsHeader-module__6r8btq__shareBtn",
  "shareLink": "NewsHeader-module__6r8btq__shareLink",
  "spacing--lg": "NewsHeader-module__6r8btq__spacing--lg",
  "spacing--md": "NewsHeader-module__6r8btq__spacing--md",
  "spacing--sm": "NewsHeader-module__6r8btq__spacing--sm",
  "spacing--xl": "NewsHeader-module__6r8btq__spacing--xl",
  "spacing--xs": "NewsHeader-module__6r8btq__spacing--xs",
  "spacing--xxl": "NewsHeader-module__6r8btq__spacing--xxl",
  "spacing--xxs": "NewsHeader-module__6r8btq__spacing--xxs",
  "spacing--xxxl": "NewsHeader-module__6r8btq__spacing--xxxl",
  "spacing--xxxs": "NewsHeader-module__6r8btq__spacing--xxxs",
  "title": "NewsHeader-module__6r8btq__title",
});
